import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Line } from 'react-chartjs-2';
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


function TemperatureGraph({ temperatureData }) {
  const { t } = useTranslation();
  let dataWater = {
    //labels: temperatureData.water?.week.map((x) => x['range']),
    datasets: [
      {        
        data: temperatureData.water_week,  //.map((x) => x['watertemp']),
        borderColor: 'rgb(0,0,255)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        parsing: {
          xAxisKey: 'range',
          yAxisKey: 'watertemp'
        },
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      }]
  }
  let dataAir = {
    //labels: temperatureData.water?.week.map((x) => x['range']),
    datasets: [
      {        
        data: temperatureData.air_week,  //.map((x) => x['watertemp']),
        borderColor: 'rgb(0, 255, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        parsing: {
          xAxisKey: 'range',
          yAxisKey: 'airtemp'
        },
        cubicInterpolationMode: 'monotone',
        tension: 0.4
      }
    ]}
    const options = {  
      tooltips:{
        enabled:false
      },      
      events: [],
      plugins: {
        legend: {
          display: false
        }
      },
      scales:{
        x: {
            display: false,
            gridLines: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false //this will remove only the label
          },
        },
        y: {
          ticks: {          
          callback: function(value, index, values) {
                    return parseFloat(value).toFixed(1) + '°';
            }
          }
        }        
      },
      elements: {      
        point: {pointStyle:false}
      }
    };
  return (
    <Container>
    <Row>
      <Col className="col-lg-6">
      
      <h1>{t('titleWaterHistory')}</h1>
      <Line       
        data={
          dataWater
        }
        options={options}>
        
      </Line>      
      </Col>
    
      <Col className="col-lg-6">
     
        <h1>{t('titleAirHistory')}</h1>      
        <Line       
          data={
            dataAir
          }
          options={options}
        ></Line>      
     
      </Col>
    </Row>
    </Container>
  );
}

export default TemperatureGraph;
